import * as React from 'react';
import $ from 'jquery';
import configData from "../config.json";
import { GetToken, GetUserId, GetSession } from '../components/Session';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export const Logs = (props) => {
    const [logs, setLogs] = React.useState([]);
    const lastCritical = React.useRef(new Date("2000-1-1"));
    const [criticalMessage, setCriticalMessage] = React.useState();
    const updateTimer = React.useRef(null);
    const period = props.period;
    const [lastLog, setLastLog] = React.useState("");
    const [logsLarge, setLogsLarge] = React.useState(false);

    React.useEffect(() => {
        UpdateLogs();
        updateTimer.current = setInterval(UpdateLogs, period * 1000);
        return () => { 
            if (updateTimer.current !== null) clearTimeout(updateTimer.current);
        }
    }, []);

    const UpdateLogs = () => {
        let url = configData.SERVER_URL + "apiv7/private/getweighbridgemessages";
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(url, init).then(response => response.json()).then(d => {
            setLogs(d);
            if (d.length > 0) setLastLog(d[0].message);
            let crit = d.find(obj => { return obj.level === "Critical" && new Date(obj.timeStamp) > lastCritical.current });
            if (crit !== undefined) {
                setCriticalMessage(crit.message);
                lastCritical.current = new Date();
            }
        });
    }

    const Acknowledge = () => {
        setCriticalMessage("");
        lastCritical.current = new Date();
    }

    const LogsClicked = () => {
        setLogsLarge(!logsLarge);
    }

    return (
        <div>
            {logsLarge && <div id="LogsPanel" onClick={LogsClicked}>{logs.map((log) => {
                return (
                    <p key={log.id} className={log.level}>{log.messageTemplate}</p>
                );
            })}
            </div>}
            {!logsLarge && <div id="LogsSmall" onClick={LogsClicked}><p>{lastLog}</p></div>}
            {criticalMessage && <Dialog title={"Critical Error"} onClose={() => Acknowledge("")}>
                <div className="errorMessage" dangerouslySetInnerHTML={{ __html: criticalMessage }}></div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => Acknowledge("")}>Acknowledge</button>
                </DialogActionsBar>
            </Dialog>}
        </div>
    );
}